export const ADDRESS = '/api/v1/admin'
export const CLIENT_ADDRESS = '/api/v1'
export const AUTHADDRESS = ''
export const HEADERS = {'Content-Type': 'application/json'}